import React, { useState } from "react";
import {
  Button,
  Grid,
  Box,
  TextField,
  Container,
  CircularProgress,
} from "@material-ui/core";
import Alert from "@material-ui/lab/Alert";
import { BLUE, WHITE_COLOR } from "../constants/color";
import halaIcon from "../assets/hala-icon.png";
import { bindActionCreators } from "redux";
import { loginUser } from "../actions/auth";
import { connect } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";

const Login = ({ loginUser }) => {
  const [loading, setLoading] = useState(false);
  const [state, setState] = useState({
    email: "",
    password: "",
  });

  const [error, setError] = useState("");

  const history = useHistory();
  const location = useLocation();

  const onSubmitLogin = async () => {
    setError("");
    setLoading(true);

    let { from } = location.state || { from: { pathname: "/" } };
    try {
      await loginUser(state);
      history.replace(from);
    } catch (error) {
      console.log(error.response);
      if (error.response) {
        setError(error.response.data.message);
      } else {
        setError("There was an issue with your request, kindly try again");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container>
      <Grid container justifyContent="flex-end">
        <Grid item xs={12} md={5}>
          <Box mr={{ md: 11 }}>
            {!!error && (
              <Alert
                severity="error"
                color="error"
                onClose={() => setError("")}
              >
                {error}
              </Alert>
            )}
          </Box>
        </Grid>
      </Grid>
      <Box mt="20%">
        <Grid container>
          <Grid item xs={12} md={7}>
            <Grid container justifyContent="center">
              <Box mb={6} mr={{ md: 40 }}>
                <img alt="hala icon" src={halaIcon} />
              </Box>
            </Grid>
          </Grid>
          <Grid item xs={12} md={4}>
            <form>
              <Grid container justifyContent="flex-end">
                <TextField
                  id="standard-number"
                  type="text"
                  label="Enter Your Email Address"
                  placeholder="e.g. "
                  variant="outlined"
                  size="small"
                  fullWidth
                  InputLabelProps={{
                    shrink: false,
                  }}
                  value={state.email}
                  onChange={(e) =>
                    setState({ ...state, email: e.target.value })
                  }
                />
                <TextField
                  // id="standard-number"
                  type="password"
                  label="Enter Your Wallet Passcode"
                  variant="outlined"
                  size="small"
                  fullWidth
                  InputLabelProps={{
                    shrink: false,
                  }}
                  value={state.passsword}
                  onChange={(e) =>
                    setState({ ...state, password: e.target.value })
                  }
                />
                <Button
                  disabled={loading}
                  onClick={onSubmitLogin}
                  variant="contained"
                  style={{ backgroundColor: BLUE, color: WHITE_COLOR }}
                  color="primary"
                  fullWidth
                >
                  {loading ? (
                    <CircularProgress disableShrink size={24} color="inherit" />
                  ) : (
                    <>Login</>
                  )}
                </Button>
              </Grid>
            </form>
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ loginUser }, dispatch);
};

export default connect(null, mapDispatchToProps)(Login);
